<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="10">
        <b-tabs class="cseit-tabs" v-model="tabIndex">
          <b-tab title="Introduction" :disabled="submittedCseit">
            <b-row>
              <b-col cols="12">
                <p class="introduction-text"><b>Pre-CSE-IT Assessment</b></p>
                <p class="introduction-text pt-4">Based on your professional judgment and the information available to you at the time of this CSE-IT assessment, <b>including information not assessed on the CSE-IT, </b>do you believe the youth is being, or has been, commercially sexually exploited?</p>
                <div v-if="initialFields">
                  <b-form-group :key="field.value" v-for="field in initialFields">
                    <b-form-radio v-model="cseit.judge_before" :value="field.value" :name="field.name" @input="judgeBeforeValidate()">{{field.label}}</b-form-radio>
                  </b-form-group>
                  <b-alert :show="!judgeBeforeValidated" variant="danger">
                       The professional judgment question is required.
                  </b-alert>
                  <b-button
                      type="button"
                      variant="primary"
                      size="md"
                      class="float-right"
                      @click="nextTab"
                    >
                      <span class="button-text">Next</span>
                  </b-button>
                   <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Questionnaire" :disabled="cseit.judge_before === ''">
            <b-row>
              <b-col cols="12">
                <div v-if="cseitQuestions">
                  <b-tabs v-model="questionIndex" active-nav-item-class="font-weight-bold text-uppercase ">
                    <b-tab title="HOUSING">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">1. HOUSING AND CAREGIVING. The youth experiences housing or caregiving instability for any reason.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('1')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}} {{question.order == '1.g' ? '∞' : ''}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 1 Score:</strong>  A subtotal of 4-5 indicates <em>Possible Concern</em>.  A subtotal ≥ 6 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionOneScoreText === 'No Concern' || questionOneScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionOneScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionOneScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(1)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                         <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="PRIOR ABUSE">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">2. PRIOR ABUSE AND TRAUMA. The youth has experienced trauma (not including exploitation).</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('2')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}} ∞</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 2 Score:</strong>  A subtotal of 2 indicates <em>Possible Concern</em>.  A subtotal ≥ 3 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm- text-center"><span v-if="questionTwoScoreText === 'No Concern' || questionTwoScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionTwoScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionTwoScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(2)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                           <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(0)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="PHYSICAL HEALTH">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">3. PHYSICAL HEALTH AND APPEARANCE.  The youth experiences notable changes in health and appearance.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('3')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 3 Score:</strong>  A subtotal of 2-3 indicates <em>Possible Concern</em>.  A subtotal ≥ 4 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionThreeScoreText === 'No Concern' || questionThreeScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionThreeScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionThreeScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(3)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(1)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="ENVIRONMENT">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">4. ENVIRONMENT AND EXPOSURE. The youth's environment or activities place them at risk of exploitation.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('4')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}} {{question.order == '4.f' ? '∞' : ''}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 4 Score:</strong>  A subtotal of 1 indicates <em>Possible Concern</em>.  A subtotal ≥ 2 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionFourScoreText === 'No Concern' || questionFourScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionFourScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionFourScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(4)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(2)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="RELATIONSHIPS">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">5. RELATIONSHIPS AND PERSONAL BELONGINGS. The youth's relationships and belongings are not consistent with their age or circumstances, suggesting possible recruitment by an exploiter.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('5')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 5 Score:</strong>  A subtotal of 1-2 indicates <em>Possible Concern</em>.  A subtotal ≥ 3 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionFiveScoreText === 'No Concern' || questionFiveScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionFiveScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionFiveScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(5)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(3)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="CURRENT TRAUMA">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">6. SIGNS OF CURRENT TRAUMA. The youth exhibits signs of trauma exposure.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('6')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 6 Score:</strong>  A subtotal of 1-2 indicates <em>Possible Concern</em>.  A subtotal ≥ 3 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionSixScoreText === 'No Concern' || questionSixScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionSixScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionSixScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(6)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(4)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="COERCION">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">7. COERCION. The youth is being controlled or coerced by another person.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('7')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 7 Score:</strong>  A subtotal of 1 indicates <em>Possible Concern</em>.  A subtotal ≥ 2 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionSevenScoreText === 'No Concern' || questionSevenScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionSevenScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionSevenScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          @click="nextQuestionTab(7)"
                         >
                           <span class="button-text">Next</span>
                         </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(5)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                    <b-tab title="EXPLOITATION">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">8. EXPLOITATION. The youth exchanges sex for money or material goods, including food or shelter.</th>
                            <th scope="col" class="text-center">No Information</th>
                            <th scope="col" class="text-center">No Concern</th>
                            <th scope="col" class="text-center">Possible Concern</th>
                            <th scope="col" class="text-center">Clear Concern</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(question, index) in filterQuestions('8')">
                              <td class="col-sm-6">{{question.order.split('.')[1]}}. {{question.questionText}} {{question.order == '8.c' ? '∞' : ''}}</td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Information" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="No Concern" :name="question.fieldName">0</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Possible Concern" :name="question.fieldName">1</b-form-radio></td>
                              <td class="col-sm-2 text-center"><b-form-radio v-model="questionAnswers[question.id]" value="Clear Concern" :name="question.fieldName">2</b-form-radio></td>
                            </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="col-sm-10"><strong>Indicator 8 Score:</strong>  A subtotal of 1 indicates <em>Possible Concern</em>.  A subtotal ≥ 2 indicates <em>Clear Concern</em>.</td>
                            <td class="col-sm-6"></td>
                            <td class="col-sm-2 text-center"><span v-if="questionEightScoreText === 'No Concern' || questionEightScoreText === ''">No Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionEightScoreText === 'Possible Concern'">Possible Concern</span></td>
                            <td class="col-sm-2 text-center"><span v-if="questionEightScoreText === 'Clear Concern'">Clear Concern</span></td>
                          </tr>
                        </tfoot>
                      </table>
                      <b-alert :show="errorFound" variant="danger">
                        The following CSE-IT questions must be answered:
                        <p v-html="errorList"></p>
                      </b-alert>
                      <div class="button-container">
                        <b-button
                          type="button"
                          variant="primary"
                          size="md"
                          class="float-right calculate-button"
                          :disabled="isCreateCseitLoading"
                          @click="calculateCseit"
                         >
                           <span class="button-text">Calculate Overall Score</span>
                         </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="nextQuestionTab(6)"
                            >
                              <span class="button-text">Previous</span>
                          </b-button>
                          <b-button
                              type="button"
                              variant="link"
                              size="md"
                              class="float-right calculate-button"
                              @click="cancelModal"
                            >
                              <span class="button-text">Cancel</span>
                          </b-button>
                       </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Score" :disabled="!submittedCseit">
            <b-row>
              <b-col cols="12">
                      <h5>Summary:</h5>
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Indicators</th>
                            <th scope="col" class="text-center">Indicator Score</th>
                            <th scope="col" class="text-center">No Information Summary</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><strong>1. Housing and Caregiving</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q1)">{{savedCseit.calc_q1}} ({{calculateSummaryNumber(questionOneScoreText)}})</td>
                            <td>{{questionOneNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>2. Prior Abuse or Trauma</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q2)">{{savedCseit.calc_q2}} ({{calculateSummaryNumber(questionTwoScoreText)}})</td>
                            <td>{{questionTwoNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>3. Physical Health and Appearance</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q3)">{{savedCseit.calc_q3}} ({{calculateSummaryNumber(questionThreeScoreText)}})</td>
                            <td>{{questionThreeNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>4. Environment and Exposure</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q4)">{{savedCseit.calc_q4}} ({{calculateSummaryNumber(questionFourScoreText)}})</td>
                            <td>{{questionFourNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>5. Relationships and Personal Belongings</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q5)">{{savedCseit.calc_q5}} ({{calculateSummaryNumber(questionFiveScoreText)}})</td>
                            <td>{{questionFiveNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>6. Signs of Current Trauma</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q6)">{{savedCseit.calc_q6}} ({{calculateSummaryNumber(questionSixScoreText)}})</td>
                            <td>{{questionSixNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>7. Coercion</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q7)">{{savedCseit.calc_q7}} ({{calculateSummaryNumber(questionSevenScoreText)}})</td>
                            <td>{{questionSevenNoInformationPercentage}}%</td>
                          </tr>
                          <tr>
                            <td><strong>8. Exploitation</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_q8)">{{savedCseit.calc_q8}} ({{calculateSummaryNumberEight(questionEightScoreText)}})</td>
                            <td>{{questionEightNoInformationPercentage}}%</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td><strong>Total:</strong></td>
                            <td v-bind:class="calculationClass(savedCseit.calc_cseitScore)"><strong>{{savedCseit.calc_cseitScore}} ({{cseitFinalScore}})</strong></td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                <h5>CSE-IT Score:</h5>
                <p>{{savedCseit.calc_cseitScore}}</p>
                <p class="introduction-text"><b>CSE-IT Continuum of Concern</b></p>
                <img src="static/img/cseit_scale.svg" height="75" />
                <p class="introduction-text"><b>Post-CSE-IT Assessment</b></p>
                <p class="introduction-text pt-4">Based on your professional judgment and the information available to you at the time of this CSE-IT, <i>including information not assessed on the CSE-IT, </i>do you believe the youth is being, or has been, commercially sexually exploited?</p>
                <div v-if="initialFields">
                  <b-form-group :key="field.value" v-for="field in initialFields">
                    <b-form-radio v-model="savedCseit.judge_after" :value="field.value" :name="field.name">{{field.label}}</b-form-radio>
                  </b-form-group>
                </div>
                <b-alert :show="!judgeAfterValidated" variant="danger">
                  The professional judgment question is required.
                </b-alert>
                <br>
                <div v-if="judgeAfterYes && judgeAfterSelected">
                  <b-form-group label="How long has the youth been exploited?" label-for="can_duration">
                    <b-form-select size="lg" :options="canDurationDefaults" id='can_duration' v-model='savedCseit.can_duration'>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group label="How old was the youth when they were exploited?" label-for="can_onset">
                    <b-form-select size="lg" :options="canOnsetDefaults" id='can_onset' v-model='savedCseit.can_onset'>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group label="Please describe the youth's perception of the dangerousness of his/her situation." label-for="can_perception">
                    <b-form-select size="lg" :options="canPerceptionDefaults" id='can_perception' v-model='savedCseit.can_perception'>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div v-if="!judgeAfterYes && judgeAfterSelected">
                  <b-form-group label="If NO, why do you believe the youth is not being commercially sexually exploited?">
                  <b-form-textarea
                    v-model="savedCseit.judge_whynot"
                  ></b-form-textarea>
                  </b-form-group>
                </div>
                <b-form-group label="Comments">
                  <b-form-textarea
                    v-model="savedCseit.comments"
                  ></b-form-textarea>
                </b-form-group>
                <!-- Adding Location and Program -->
                <p class="introduction-text"><b>Select your CSE-IT Location and Program:</b></p>
                <p>Select the location and/or program where this CSE-IT screening occurred. If no location/program is selected, it will default to the primary location/program of the organization.</p>
                <!-- Added Location -->
                <b-form-group label-size='lg' label="Location" label-for="cseit_location" :horizontal='false'>
                  <b-form-select
                    id='cseit_location'
                    :options="locationOptions"
                    v-model="savedCseit.cseit_location"
                    placeholder='Select a Location'
                  >
                  {{ savedCseit.cseit_location }}
                  </b-form-select>
                </b-form-group>

                <!-- Added Program -->
                <b-form-group label-size='lg' label="Program"  label-for="cseit_program" :horizontal='false'>
                  <b-form-select
                    id='cseit_program'
                    :options="programOptions"
                    v-model="savedCseit.cseit_program"
                    placeholder='Select a Program'
                  >
                  {{ savedCseit.cseit_program }}
                  </b-form-select>
                </b-form-group>

                <!-- Next Steps (TX and Clear Concern only) -->
                <div v-if='isUserInTX && savedCseit.calc_cseitScore === "Clear Concern"'>
                  <p class="introduction-text pt-4"><b>Next Steps</b></p>
                  <p>Refer the youth for appropriate services, which may include:</p>
                  <ul>
                    <li><b>Care Coordination</b>, and/or</li>
                    <li><b>Commercially Sexually Exploited Youth (CSEY) Advocacy</b></li>
                  </ul>
                  <p>You may visit the <a href='http://gov.texas.gov/cstt' target='_blank'>Office of the Governor Child Sex Trafficking Team website</a> to locate the Care Coordination Team and CSEY Advocate Agency in your county. If you are unsure whether Care Coordination is available in your county, or need assistance identifying the designated CSEY Advocacy provider for your region, please contact the Child Sex Trafficking Team for guidance at: <a href='mailto:cstt@gov.texas.gov'>cstt@gov.texas.gov</a></p>
                </div>

                <b-button
                  type="button"
                  variant="primary"
                  size="md"
                  class="float-right"
                  @click="updateCseit"
                >
                  <span class="button-text">Submit</span>
                </b-button>
                <!-- Removed Cancel -->
                <!-- <b-button
                  type="button"
                  variant="link"
                  size="md"
                  class="float-right"
                  @click="cancelModal"
                >
                  <span class="button-text">Cancel</span>
                </b-button> -->
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
      <b-modal
        ref="cancelModal"
        centered id="myModal"
        title="Cancel CSE-IT"
        size="lg"
        ok-title="No, return to CSE-IT"
        cancel-title="Yes, cancel"
        header-bg-variant="success"
        header-text-variant="light"
        class="tos-modal"
        hide-header-close
        no-close-on-backdrop
    >
      <p>Are you sure you want to cancel this CSE-IT? The information you entered will not be saved.</p>
    </b-modal>
    <b-modal
        ref="confirmModal"
        centered id="myConfirmModal"
        title="Professional Judgment Required"
        size="lg"
        ok-only
        ok-title="Return to CSE-IT"
        header-bg-variant="success"
        header-text-variant="light"
        class="tos-modal"
        hide-header-close
        no-close-on-backdrop
    >
      <p>The professional judgment question is required. Please complete this and click Submit.</p>
    </b-modal>
    <b-modal
      ref="submitModal"
      centered id="mySubmitModal"
      title="Submit CSE-IT"
      size="lg"
      ok-only
      ok-title="Return to CSE-IT"
      header-bg-variant="success"
      header-text-variant="light"
      class="tos-modal"
      hide-header-close
      no-close-on-backdrop
    >
      <p>Please submit this CSE-IT.</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { calculateNumericScoreValue, calculateQuestionScore } from '@/helpers/cseit'
import userStateMixin from '@/mixins/userState.js'

export default {
  name: 'add-cseit',
  mixins: [userStateMixin],
  beforeRouteLeave (to, from, next) {
    // Leaving form before entering Professional Judgement
    if (this.displayNavigationPrompt && this.submittedCseit && this.savedCseit.judge_after === '') {
      this.showConfirmModal()
      this.$nextTick(() => {
        this.$refs.confirmModal.$once('hide', (bvEvt) => {
          if (bvEvt.trigger === 'cancel') {
            this.$refs.confirmModal.$once('hidden', () => { next() })
          } else {
            next(false)
          }
        })
      })
    } else if (this.submittedCseit && this.judgeAfterValidated && this.displayNavigationPrompt) {
      // Leaving form after Professional Judgement has been submitted
      this.showSubmitModal()
      this.$nextTick(() => {
        this.$refs.submitModal.$once('hide', (bvEvt) => {
          if (bvEvt.trigger === 'cancel') {
            this.$refs.submitModal.$once('hidden', () => { next() })
          } else {
            next(false)
          }
        })
      })
    } else if (this.submittedCseit && this.judgeAfterValidated && this.displayNavigationPrompt === false) {
      // Leaving form after submit
      next()
    } else {
      // Leaving form during question section
      this.submittedCseit = false
      this.showLeaveModal()
      this.$nextTick(() => {
        this.$refs.cancelModal.$once('hide', (bvEvt) => {
          if (bvEvt.trigger === 'cancel') {
            this.$refs.cancelModal.$once('hidden', () => { next() })
          } else {
            next(false)
          }
        })
      })
    }
  },
  computed: {
    ...mapGetters({
      /* authenticatedUserMemberships: 'authenticatedUserMemberships', */
      cseit: 'getCreateCseit',
      createdCseit: 'getRecentlyCreatedCseit',
      cseitQuestions: 'getCseitQuestions',
      initialFields: 'getInitialFields',
      canDurationDefaults: 'getCanDurationDefaults',
      canOnsetDefaults: 'getCanOnsetDefaults',
      canPerceptionDefaults: 'getCanPerceptionDefaults',
      person: 'getEditPerson',
      questionnaireFields: 'getQuestionnaireFields',
      userCurrentContext: 'userCurrentContext',
      orgPrograms: 'getProgramsByOrg',
      orgLocations: 'getLocationsByOrg'
    }),
    judgeAfterYes: function () {
      if (this.savedCseit.judge_after === 'Yes' || this.savedCseit.judge_after === 'I believe') {
        this.judgeAfterSelected = true
        return true
      } else if (this.savedCseit.judge_after === 'I do not believe' || this.savedCseit.judge_after === 'No' || this.savedCseit.judge_after === 'Unknown') {
        this.judgeAfterSelected = true
        return false
      } else {
        return false
      }
    }
  },
  watch: {
    orgPrograms: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        const defaultProgramId = _.get(this.userCurrentContext, 'organization.defaultProgram', false) || newValue[0].id
        this.programOptions = clonedValue.map((program) => {
          let text = program.title
          if (program.title === 'Other') {
            text = program.title_otherText
          }
          return {
            value: program.id, text
          }
        })
        console.log('defaultProg', defaultProgramId)
        this.savedCseit.cseit_program = defaultProgramId
      }
    },
    orgLocations: function (newValue) {
      if (newValue) {
        let clonedValue = Object.assign([], newValue)
        clonedValue.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)
        const defaultLocationId = _.get(this.userCurrentContext, 'organization.defaultLocation', false) || newValue[0].id
        var newArray = clonedValue.filter((value) => !value.isRemoved)
        this.locationOptions = newArray.map((location) => {
          return {
            value: location.id, text: location.title
          }
        })
        console.log('defaultLoc', defaultLocationId)
        this.savedCseit.cseit_location = defaultLocationId
      }
    },
    cseitQuestions: function (newValue) {
      if (newValue) {
        this.questions = Object.assign([], newValue)

        this.questions.sort(function (a, b) {
          if (a.order.split('.')[0] > b.order.split('.')[0]) {
            return 1
          } else if (a.order.split('.')[0] < b.order.split('.')[0]) {
            return -1
          } else {
            if (a.order.split('.')[1] > b.order.split('.')[1]) {
              return 1
            } else if (a.order.split('.')[1] < b.order.split('.')[1]) {
              return -1
            } else {
              return 0
            }
          }
        })

        for (let question of this.questions) {
          this.questionAnswers[question.id] = null
        }
      }
    },
    createdCseit: function (newValue) {
      if (newValue) {
        const cseitLoc = this.savedCseit.cseit_location
        const cseitProgram = this.savedCseit.cseit_program
        this.savedCseit = Object.assign(this.savedCseit, newValue)
        if (!newValue.cseit_location) {
          this.savedCseit.cseit_location = cseitLoc
        }
        if (!newValue.cseit_program) {
          this.savedCseit.cseit_program = cseitProgram
        }
      }
    },
    questionAnswers: function (newValue) {
      let localTotalOne = 0
      let localTotalTwo = 0
      let localTotalThree = 0
      let localTotalFour = 0
      let localTotalFive = 0
      let localTotalSix = 0
      let localTotalSeven = 0
      let localTotalEight = 0
      let i = 0

      this.questionAnswers.forEach(() => {
        if (this.questions[i]) {
          let questionNumberPart = this.questions[i].order.split('.')[0]
          let value = calculateNumericScoreValue(this.questionAnswers[this.questions[i].id])

          if (questionNumberPart === '1') {
            localTotalOne += value
          } else if (questionNumberPart === '2') {
            localTotalTwo += value
          } else if (questionNumberPart === '3') {
            localTotalThree += value
          } else if (questionNumberPart === '4') {
            localTotalFour += value
          } else if (questionNumberPart === '5') {
            localTotalFive += value
          } else if (questionNumberPart === '6') {
            localTotalSix += value
          } else if (questionNumberPart === '7') {
            localTotalSeven += value
          } else if (questionNumberPart === '8') {
            localTotalEight += value
          }
        }

        i++
      })

      this.questionOneScore = localTotalOne
      this.questionOneScoreText = calculateQuestionScore(this.questionOneScore, 'One')
      this.questionTwoScore = localTotalTwo
      this.questionTwoScoreText = calculateQuestionScore(this.questionTwoScore, 'Two')
      this.questionThreeScore = localTotalThree
      this.questionThreeScoreText = calculateQuestionScore(this.questionThreeScore, 'Three')
      this.questionFourScore = localTotalFour
      this.questionFourScoreText = calculateQuestionScore(this.questionFourScore, 'Four')
      this.questionFiveScore = localTotalFive
      this.questionFiveScoreText = calculateQuestionScore(this.questionFiveScore, 'Five')
      this.questionSixScore = localTotalSix
      this.questionSixScoreText = calculateQuestionScore(this.questionSixScore, 'Six')
      this.questionSevenScore = localTotalSeven
      this.questionSevenScoreText = calculateQuestionScore(this.questionSevenScore, 'Seven')
      this.questionEightScore = localTotalEight
      this.questionEightScoreText = calculateQuestionScore(this.questionEightScore, 'Eight')
    }
  },
  data: function () {
    return {
      isCreateCseitLoading: false,
      tabIndex: 0,
      questionIndex: 0,
      initialAnswer: '',
      questions: [],
      questionAnswers: [],
      submittedCseit: false,
      questionOneScore: 0,
      questionOneScoreText: 'No Concern',
      questionTwoScore: 0,
      questionTwoScoreText: 'No Concern',
      questionThreeScore: 0,
      questionThreeScoreText: 'No Concern',
      questionFourScore: 0,
      questionFourScoreText: 'No Concern',
      questionFiveScore: 0,
      questionFiveScoreText: 'No Concern',
      questionSixScore: 0,
      questionSixScoreText: 'No Concern',
      questionSevenScore: 0,
      questionSevenScoreText: 'No Concern',
      questionEightScore: 0,
      questionEightScoreText: 'No Concern',
      questionOneNoInformationPercentage: 0,
      questionTwoNoInformationPercentage: 0,
      questionThreeNoInformationPercentage: 0,
      questionFourNoInformationPercentage: 0,
      questionFiveNoInformationPercentage: 0,
      questionSixNoInformationPercentage: 0,
      questionSevenNoInformationPercentage: 0,
      questionEightNoInformationPercentage: 0,
      cseitFinalScore: 0,
      showCancelModal: false,
      judgeAfterSelected: false,
      savedCseit: {},
      judgeBeforeValidated: true,
      judgeAfterValidated: true,
      errorFound: false,
      errorQuestions: [],
      errorList: '',
      displayNavigationPrompt: true,
      answer: null,
      programOptions: [],
      locationOptions: [],
      defaultLocation: '',
      defaultProgram: ''
    }
  },
  methods: {
    showLeaveModal () {
      this.$refs.cancelModal.show()
    },
    handleLeaveModalOk () {
      this.answer = 'OK'
    },
    showConfirmModal () {
      this.$refs.confirmModal.show()
    },
    showSubmitModal () {
      this.$refs.submitModal.show()
    },
    showModal () {
      if (this.$refs.cancelModal) {
        this.$refs.cancelModal.show()
      }
    },
    hideModal () {
      if (this.$refs.cancelModal) {
        this.$refs.cancelModal.hide()
      }
    },
    cancelModal () {
      if (this.$refs.cancelModal) {
        this.$refs.cancelModal.hide()
      }
      const friendlyPersonId = this.$route.params.id
      this.$router.push({path: '/person/' + friendlyPersonId})
    },
    judgeBeforeValidate: function () {
      if (this.cseit.judge_before === '') {
        this.judgeBeforeValidated = false
      } else {
        this.judgeBeforeValidated = true
      }
    },
    nextTab: function () {
      if (this.cseit.judge_before === '') {
        this.judgeBeforeValidated = false
      } else {
        this.judgeBeforeValidated = true
        this.tabIndex++
      }
    },
    previousTab: function () {
      this.tabIndex--
    },
    nextQuestionTab: function (index) {
      this.questionIndex = index
    },
    filterQuestions: function (questionNumber) {
      return this.questions.filter(function (question) {
        return question.order.split('.')[0] === questionNumber
      })
    },
    calculateSummaryNumber: function (text) {
      if (text === 'No Concern') {
        return 0
      } else if (text === 'Possible Concern') {
        return 1
      } else {
        return 2
      }
    },
    calculateSummaryNumberEight: function (text) {
      if (text === 'No Concern') {
        return 0
      } else if (text === 'Possible Concern') {
        return 4
      } else {
        return 9
      }
    },
    calculateCseit: function () {
      this.isCreateCseitLoading = true
      let nullFound = false
      this.errorList = ''
      this.errorQuestions = []

      let i = 0

      this.questions.forEach(() => {
        if (!this.questionAnswers[this.questions[i].id]) {
          nullFound = true
          this.errorQuestions[this.questions[i].id] = this.questions[i].order
        }

        i++
      })

      if (nullFound) {
        this.errorFound = true

        this.errorQuestions.sort(function (a, b) {
          if (a.split('.')[0] > b.split('.')[0]) {
            return 1
          } else if (a.split('.')[0] < b.split('.')[0]) {
            return -1
          } else {
            if (a.split('.')[1] > b.split('.')[1]) {
              return 1
            } else if (a.split('.')[1] < b.split('.')[1]) {
              return -1
            } else {
              return 0
            }
          }
        })

        this.errorQuestions.forEach((value, index) => {
          if (this.questions[index]) {
            this.errorList += value + '<br/>'
          }
        })
        this.isCreateCseitLoading = false
        return false
      }

      this.errorFound = false
      this.errorList = ''

      // Pull the data out of the answers array...
      i = 0

      let questionOneTotal = 0
      let questionOneNoInformation = 0
      let questionTwoTotal = 0
      let questionTwoNoInformation = 0
      let questionThreeTotal = 0
      let questionThreeNoInformation = 0
      let questionFourTotal = 0
      let questionFourNoInformation = 0
      let questionFiveTotal = 0
      let questionFiveNoInformation = 0
      let questionSixTotal = 0
      let questionSixNoInformation = 0
      let questionSevenTotal = 0
      let questionSevenNoInformation = 0
      let questionEightTotal = 0
      let questionEightNoInformation = 0

      this.questionAnswers.forEach(() => {
        if (this.questions[i]) {
          let fieldName = this.questions[i].fieldName

          switch (fieldName) {
            case 'one_a_running':
              questionOneTotal++
              this.cseit.one_a_running = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_a_running === 'No Information') { questionOneNoInformation++ }
              break
            case 'one_b_housing':
              questionOneTotal++
              this.cseit.one_b_housing = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_b_housing === 'No Information') { questionOneNoInformation++ }
              break
            case 'one_c_homeless':
              questionOneTotal++
              this.cseit.one_c_homeless = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_c_homeless === 'No Information') { questionOneNoInformation++ }
              break
            case 'one_d_services':
              questionOneTotal++
              this.cseit.one_d_services = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_d_services === 'No Information') { questionOneNoInformation++ }
              break
            case 'one_e_supervision':
              questionOneTotal++
              this.cseit.one_e_supervision = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_e_supervision === 'No Information') { questionOneNoInformation++ }
              break
            case 'one_f_school':
              questionOneTotal++
              this.cseit.one_f_school = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_f_school === 'No Information') { questionOneNoInformation++ }
              break
            case 'one_g_cps':
              questionOneTotal++
              this.cseit.one_g_cps = this.questionAnswers[this.questions[i].id]
              if (this.cseit.one_g_cps === 'No Information') { questionOneNoInformation++ }
              break
            case 'two_a_secabuse':
              questionTwoTotal++
              this.cseit.two_a_secabuse = this.questionAnswers[this.questions[i].id]
              if (this.cseit.two_a_secabuse === 'No Information') { questionTwoNoInformation++ }
              break
            case 'two_b_physicalabuse':
              questionTwoTotal++
              this.cseit.two_b_physicalabuse = this.questionAnswers[this.questions[i].id]
              if (this.cseit.two_b_physicalabuse === 'No Information') { questionTwoNoInformation++ }
              break
            case 'two_c_emotionalabuse':
              questionTwoTotal++
              this.cseit.two_c_emotionalabuse = this.questionAnswers[this.questions[i].id]
              if (this.cseit.two_c_emotionalabuse === 'No Information') { questionTwoNoInformation++ }
              break
            case 'two_d_violence':
              questionTwoTotal++
              this.cseit.two_d_violence = this.questionAnswers[this.questions[i].id]
              if (this.cseit.two_d_violence === 'No Information') { questionTwoNoInformation++ }
              break
            case 'three_a_appearance':
              questionThreeTotal++
              this.cseit.three_a_appearance = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_a_appearance === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_b_phystrauma':
              questionThreeTotal++
              this.cseit.three_b_phystrauma = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_b_phystrauma === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_c_tattoo':
              questionThreeTotal++
              this.cseit.three_c_tattoo = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_c_tattoo === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_d_pregsti':
              questionThreeTotal++
              this.cseit.three_d_pregsti = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_d_pregsti === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_e_sleep':
              questionThreeTotal++
              this.cseit.three_e_sleep = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_e_sleep === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_f_nutrition':
              questionThreeTotal++
              this.cseit.three_f_nutrition = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_f_nutrition === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_g_sud':
              questionThreeTotal++
              this.cseit.three_g_sud = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_g_sud === 'No Information') { questionThreeNoInformation++ }
              break
            case 'three_h_increasesud':
              questionThreeTotal++
              this.cseit.three_h_increasesud = this.questionAnswers[this.questions[i].id]
              if (this.cseit.three_h_increasesud === 'No Information') { questionThreeNoInformation++ }
              break
            case 'four_a_risksex':
              questionFourTotal++
              this.cseit.four_a_risksex = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_a_risksex === 'No Information') { questionFourNoInformation++ }
              break
            case 'four_b_location':
              questionFourTotal++
              this.cseit.four_b_location = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_b_location === 'No Information') { questionFourNoInformation++ }
              break
            case 'four_c_language':
              questionFourTotal++
              this.cseit.four_c_language = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_c_language === 'No Information') { questionFourNoInformation++ }
              break
            case 'four_d_association':
              questionFourTotal++
              this.cseit.four_d_association = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_d_association === 'No Information') { questionFourNoInformation++ }
              break
            case 'four_e_bullied':
              questionFourTotal++
              this.cseit.four_e_bullied = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_e_bullied === 'No Information') { questionFourNoInformation++ }
              break
            case 'four_f_jj':
              questionFourTotal++
              this.cseit.four_f_jj = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_f_jj === 'No Information') { questionFourNoInformation++ }
              break
            case 'four_g_gang':
              questionFourTotal++
              this.cseit.four_g_gang = this.questionAnswers[this.questions[i].id]
              if (this.cseit.four_g_gang === 'No Information') { questionFourNoInformation++ }
              break
            case 'five_a_unhealthyrel':
              questionFiveTotal++
              this.cseit.five_a_unhealthyrel = this.questionAnswers[this.questions[i].id]
              if (this.cseit.five_a_unhealthyrel === 'No Information') { questionFiveNoInformation++ }
              break
            case 'five_b_onlinerel':
              questionFiveTotal++
              this.cseit.five_b_onlinerel = this.questionAnswers[this.questions[i].id]
              if (this.cseit.five_b_onlinerel === 'No Information') { questionFiveNoInformation++ }
              break
            case 'five_c_photos':
              questionFiveTotal++
              this.cseit.five_c_photos = this.questionAnswers[this.questions[i].id]
              if (this.cseit.five_c_photos === 'No Information') { questionFiveNoInformation++ }
              break
            case 'five_d_money':
              questionFiveTotal++
              this.cseit.five_d_money = this.questionAnswers[this.questions[i].id]
              if (this.cseit.five_d_money === 'No Information') { questionFiveNoInformation++ }
              break
            case 'five_e_manyphones':
              questionFiveTotal++
              this.cseit.five_e_manyphones = this.questionAnswers[this.questions[i].id]
              if (this.cseit.five_e_manyphones === 'No Information') { questionFiveNoInformation++ }
              break
            case 'five_f_travel':
              questionFiveTotal++
              this.cseit.five_f_travel = this.questionAnswers[this.questions[i].id]
              if (this.cseit.five_f_travel === 'No Information') { questionFiveNoInformation++ }
              break
            case 'six_a_hypervigilant':
              questionSixTotal++
              this.cseit.six_a_hypervigilant = this.questionAnswers[this.questions[i].id]
              if (this.cseit.six_a_hypervigilant === 'No Information') { questionSixNoInformation++ }
              break
            case 'six_b_cues':
              questionSixTotal++
              this.cseit.six_b_cues = this.questionAnswers[this.questions[i].id]
              if (this.cseit.six_b_cues === 'No Information') { questionSixNoInformation++ }
              break
            case 'six_c_risktaking':
              questionSixTotal++
              this.cseit.six_c_risktaking = this.questionAnswers[this.questions[i].id]
              if (this.cseit.six_c_risktaking === 'No Information') { questionSixNoInformation++ }
              break
            case 'six_d_celldistress':
              questionSixTotal++
              this.cseit.six_d_celldistress = this.questionAnswers[this.questions[i].id]
              if (this.cseit.six_d_celldistress === 'No Information') { questionSixNoInformation++ }
              break
            case 'seven_a_abusive':
              questionSevenTotal++
              this.cseit.seven_a_abusive = this.questionAnswers[this.questions[i].id]
              if (this.cseit.seven_a_abusive === 'No Information') { questionSevenNoInformation++ }
              break
            case 'seven_b_isolation':
              questionSevenTotal++
              this.cseit.seven_b_isolation = this.questionAnswers[this.questions[i].id]
              if (this.cseit.seven_b_isolation === 'No Information') { questionSevenNoInformation++ }
              break
            case 'seven_c_pregnant':
              questionSevenTotal++
              this.cseit.seven_c_pregnant = this.questionAnswers[this.questions[i].id]
              if (this.cseit.seven_c_pregnant === 'No Information') { questionSevenNoInformation++ }
              break
            case 'seven_d_coercion':
              questionSevenTotal++
              this.cseit.seven_d_coercion = this.questionAnswers[this.questions[i].id]
              if (this.cseit.seven_d_coercion === 'No Information') { questionSevenNoInformation++ }
              break
            case 'seven_e_threats':
              questionSevenTotal++
              this.cseit.seven_e_threats = this.questionAnswers[this.questions[i].id]
              if (this.cseit.seven_e_threats === 'No Information') { questionSevenNoInformation++ }
              break
            case 'seven_f_vague':
              questionSevenTotal++
              this.cseit.seven_f_vague = this.questionAnswers[this.questions[i].id]
              if (this.cseit.seven_f_vague === 'No Information') { questionSevenNoInformation++ }
              break
            case 'eight_a_exploited':
              questionEightTotal++
              this.cseit.eight_a_exploited = this.questionAnswers[this.questions[i].id]
              if (this.cseit.eight_a_exploited === 'No Information') { questionEightNoInformation++ }
              break
            case 'eight_b_filmed':
              questionEightTotal++
              this.cseit.eight_b_filmed = this.questionAnswers[this.questions[i].id]
              if (this.cseit.eight_b_filmed === 'No Information') { questionEightNoInformation++ }
              break
            case 'eight_c_history':
              questionEightTotal++
              this.cseit.eight_c_history = this.questionAnswers[this.questions[i].id]
              if (this.cseit.eight_c_history === 'No Information') { questionEightNoInformation++ }
              break
            case 'eight_d_quota':
              questionEightTotal++
              this.cseit.eight_d_quota = this.questionAnswers[this.questions[i].id]
              if (this.cseit.eight_d_quota === 'No Information') { questionEightNoInformation++ }
              break
          }
        }

        i++
      })

      this.cseit.calc_q1 = this.questionOneScoreText
      this.cseit.calc_q2 = this.questionTwoScoreText
      this.cseit.calc_q3 = this.questionThreeScoreText
      this.cseit.calc_q4 = this.questionFourScoreText
      this.cseit.calc_q5 = this.questionFiveScoreText
      this.cseit.calc_q6 = this.questionSixScoreText
      this.cseit.calc_q7 = this.questionSevenScoreText
      this.cseit.calc_q8 = this.questionEightScoreText

      this.questionOneNoInformationPercentage = parseFloat(parseFloat(parseInt(questionOneNoInformation) / parseInt(questionOneTotal)) * 100).toFixed(2)
      this.questionTwoNoInformationPercentage = parseFloat(parseFloat(parseInt(questionTwoNoInformation) / parseInt(questionTwoTotal)) * 100).toFixed(2)
      this.questionThreeNoInformationPercentage = parseFloat(parseFloat(parseInt(questionThreeNoInformation) / parseInt(questionThreeTotal)) * 100).toFixed(2)
      this.questionFourNoInformationPercentage = parseFloat(parseFloat(parseInt(questionFourNoInformation) / parseInt(questionFourTotal)) * 100).toFixed(2)
      this.questionFiveNoInformationPercentage = parseFloat(parseFloat(parseInt(questionFiveNoInformation) / parseInt(questionFiveTotal)) * 100).toFixed(2)
      this.questionSixNoInformationPercentage = parseFloat(parseFloat(parseInt(questionSixNoInformation) / parseInt(questionSixTotal)) * 100).toFixed(2)
      this.questionSevenNoInformationPercentage = parseFloat(parseFloat(parseInt(questionSevenNoInformation) / parseInt(questionSevenTotal)) * 100).toFixed(2)
      this.questionEightNoInformationPercentage = parseFloat(parseFloat(parseInt(questionEightNoInformation) / parseInt(questionEightTotal)) * 100).toFixed(2)

      let cseitFirstPart = this.calculateSummaryNumber(this.questionOneScoreText) + this.calculateSummaryNumber(this.questionTwoScoreText) + this.calculateSummaryNumber(this.questionThreeScoreText) + this.calculateSummaryNumber(this.questionFourScoreText) + this.calculateSummaryNumber(this.questionFiveScoreText) + this.calculateSummaryNumber(this.questionSixScoreText) + this.calculateSummaryNumber(this.questionSevenScoreText)

      let cseitSecondPart = 0

      if (this.questionEightScoreText === 'Possible Concern') {
        cseitSecondPart = 4
      } else if (this.questionEightScoreText === 'Clear Concern') {
        cseitSecondPart = 9
      }

      this.cseitFinalScore = cseitFirstPart + cseitSecondPart
      let cseitFinalScoreText = ''

      if (this.cseitFinalScore <= 3) {
        cseitFinalScoreText = 'No Concern'
      } else if (this.cseitFinalScore > 3 && this.cseitFinalScore <= 8) {
        cseitFinalScoreText = 'Possible Concern'
      } else {
        cseitFinalScoreText = 'Clear Concern'
      }

      this.cseit.calc_cseitScore = cseitFinalScoreText
      this.$store.dispatch('createCseit', this.cseit).then(response => {
        this.submittedCseit = true
        window.scrollTo(0, 0)
        this.tabIndex++
        this.isCreateCseitLoading = false
      })
    },
    updateCseit: function () {
      if (this.savedCseit.judge_after === '') {
        this.judgeAfterValidated = false
      } else {
        console.log('submitted')
        this.judgeAfterValidated = true
        this.savedCseit.p_finishdts = Date.now()
        this.savedCseit.p_duration = Math.floor((this.savedCseit.p_finishdts - this.savedCseit.p_startdts) / 1000)
        this.displayNavigationPrompt = false
        const friendlyPersonId = this.$route.params.id
        this.$store.dispatch('updateCseit', this.savedCseit).then(response => {
          this.$router.push({path: '/person/' + friendlyPersonId})
        })
      }
    },
    /* initializeOwningOrganization: function (memberships) {
      let umo

      if (memberships.length === 1) {
        umo = memberships[0]
      } else {
        const user = this.$auth.user()
        const primaryOrganization = _.get(user, 'primaryOrganization.id', false)
        umo = memberships.find((umo) => umo.morganization.id === primaryOrganization)
      }

      if (umo) {
        this.assignOrganization(umo)
      }
    }, */
    assignOrganization: function (umo) {
      const orgId = _.get(umo, 'morganization.id')
      const defaultLocationId = _.get(umo, 'morganization.defaultLocation')
      const defaultProgramId = _.get(umo, 'morganization.defaultProgram')
      if (orgId) {
        this.cseit.organizationCreator = orgId
        this.cseit.organizationOwner = orgId
        this.defaultLocation = defaultLocationId
        this.defaultProgram = defaultProgramId
      }
    },
    calculationClass: function (name) {
      if (name === 'Clear Concern') {
        return 'text-danger'
      } else if (name === 'Possible Concern') {
        return 'text-warning'
      } else {
        return ''
      }
    },
    searchGroups () {
      this.$store.dispatch('getLocationsByOrg', { orgId: this.cseit.organizationCreator })
      this.$store.dispatch('getProgramsByOrg', { orgId: this.cseit.organizationCreator })
    }
  },
  created () {
    this.initializeOwningOrganization = _.get(this.userCurrentContext, 'organization.id', false)
    console.log('AddCseit - Created Deatils initialOwningOrg = ' + this.initializeOwningOrganization)

    // const user = this.$auth.user()
    const userId = _.get(this.userCurrentContext, 'userMember.muser', false)
    const friendlyPersonId = this.$route.params.id
    const orgId = _.get(this.userCurrentContext, 'organization.id', false)
    const groupId = _.get(this.userCurrentContext, 'group.id', false)

    console.log('AddCseit - Created Deatils: orgId=' + orgId + ' groupdId=' + groupId)

    this.cseit.p_startdts = Date.now()
    this.cseit.createdBy = userId
    this.cseit.updatedBy = userId
    this.cseit.organizationCreator = orgId
    this.cseit.organizationOwner = orgId

    if (friendlyPersonId) {
      this.$store.dispatch('getPersonForEdit', {
        id: friendlyPersonId,
        orgId: orgId,
        groupId: groupId
      }).then(() => {
        this.cseit.person = this.person._id
        this.searchGroups()
      })
    }
    this.$store.dispatch('getCseitQuestions')
  }
}
</script>
<style>
  .cseit-tabs{
    margin-bottom: 40px;
  }
  .introduction-text{
    font-size: 18px;
  }
  .calculate-button{
    margin-top: 60px;
  }
  .dg-btn{
    background-color: #20a8d8;
    color: #FFFFFF;
    font-weight: normal;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/t1/Admin/AddCseit.vue